(function(angular){
    'use strict';

    angular.module('onvio.setup.notifications').controller('onvio.setup.notifications.BmNotificationsController', bmNotifications);
    bmNotifications.$inject = [];

    function bmNotifications(){
    }
})(window.angular);
